import styled from 'styled-components';

import { IconCheck } from '../../../common/icons/cdl/Check';
import { theme } from '../../../common/ui/theme';

export const OptionCheck = styled(IconCheck)`
    color: ${theme.colors.accent.foreground};
    justify-self: end;

    [data-combo-box-double-line-option] ~ & {
        align-self: start;
        margin-top: ${theme.space[12]};
    }
`;
